export default __webpack_public_path__ + "static/media/Dec6Logo.98c53c5f.svg";